import React from 'react'
import '../styles/about.css'
import Links from '../components/Links/links'
import AboutCards from './../components/AboutCards/AboutCards';
import Helmet from '../components/Helmet/Helmet';
import Gc from '../components/Gc/Gc';

import aboutMeImage from '../assets/images/IMG_6562-qjnwpn97h3z3kl6y7l5ie101zlmz0paudjlsa8yhgg.jpg'
import brands from '../assets/images/brands.webp'
import Monkey_Photographers from '../assets/images/35-Awards-Top-5-Monkey-Photographers.jpg'
import ceylon_today from '../assets/images/ceylon-today-2.jpg'
import youtube from '../assets/images/mobile-18-1536x882.png (1).webp'

// galley images
import ravisara_jayamanna_6 from '../assets/images/ravisara-jayamanna-6-731x1024.webp'
import ravisara_jayamanna_2 from '../assets/images/ravisara-jayamanna-2-731x1024.webp'
import ravisara_jayamanna_4 from '../assets/images/ravisara-jayamanna-4-731x1024.webp'
import ravisara_jayamanna_7 from '../assets/images/ravisara-jayamanna-7-731x1024.webp'
import ravisara_jayamanna_5 from '../assets/images/ravisara-jayamanna-5-731x1024.webp'
import ravisara_jayamanna_3 from '../assets/images/ravisara-jayamanna-3-732x1024.webp'

import IMG_20240206_WA0058 from '../assets/images/IMG-20240206-WA0058.jpg'
import IMG_20240206_WA0055 from '../assets/images/IMG-20240206-WA0055.jpg'
import IMG_20240206_WA0057 from '../assets/images/IMG-20240206-WA0057.jpg'
import IMG_20240206_WA0061 from '../assets/images/IMG-20240206-WA0061.jpg'
import ravisara_jayamanna from '../assets/images/ravisara-jayamanna.jpg'

const items1 = [
  { xs: 6, imgSrc: IMG_20240206_WA0058 },
  { xs: 6, imgSrc: IMG_20240206_WA0055 },
  { xs: 6, imgSrc: IMG_20240206_WA0057 },
  { xs: 4, imgSrc: IMG_20240206_WA0061 },
  { xs: 2, imgSrc: ravisara_jayamanna },
];
const items2 = [
  { xs: 2, imgSrc: ravisara_jayamanna_6 },
  { xs: 2, imgSrc: ravisara_jayamanna_2 },
  { xs: 2, imgSrc: ravisara_jayamanna_4 },
  { xs: 2, imgSrc: ravisara_jayamanna_7 },
  { xs: 2, imgSrc: ravisara_jayamanna_5 },
  { xs: 2, imgSrc: ravisara_jayamanna_3 },
];

const About = () => {
  return <>
  <Helmet title={'About'}>
  <div className="about__main-section">
    <div className="w-1">
      <div className="about__me fsba">
        <div className="about__me-img">
          <img src={aboutMeImage} alt="" />
        </div>
        <div className="about__me-content">
          <h2 className='about__heading'>About Ravisara Jayamanna</h2>
          <p>My name is Ravisara Jayamanna, a 24-year-old wildlife tour guide and award-winning photographer based in Sri Lanka. Specialized in leopards, birds, reptiles, and amphibians, I collaborate on leopard research programs with local organizations. Featured on BBC, Natgeo, Discovery, and Nikon, I lead wildlife photography workshops and lectures, merging my passion for nature with photography. Offering affordable wildlife photography tours, I provide unparalleled experiences and expert guidance, drawing from my five years of field expertise.</p>
          <h2 className='about__heading'>Awards :</h2>
          <ul className='about_ul'>
            <li className='about_list-items'><a href="https://www.instagram.com/p/CaEV0BVP03Q/?igshid=MDM4ZDc5MmU" target='_blank' rel='noopener noreferrer'>NatureInfocus Finalist</a></li>
            <li className='about_list-items'>State Festival of Photography</li>
            <li className='about_list-items'><a href="https://35awards.com/page/contests/num/554/photographers/" target='_blank' rel='noopener noreferrer'>35 Awards Top 5 Monkey Photographers</a></li>
            <li className='about_list-items'>Wild Sri Lanka Photographer of the Year 2018</li>
            <li className='about_list-items'>NPAS 43rd Annual Photography 2019</li>
            <li className='about_list-items'>SLAAS Nature E Photo Contest 2019</li>
            <li className='about_list-items'>Wild Sri Lanka Photographer of the Year 2022</li>
          </ul>
          <h2 className='about__heading'>Featured On :</h2>
          <ul className='about_ul'>
            <li className='about_list-items'><a href="https://www.instagram.com/stories/highlights/17917094828196033/" target='_blank' rel='noopener noreferrer'>Nikon</a></li>
            <li className='about_list-items'><a href="https://www.instagram.com/stories/highlights/18251306767148143/" target='_blank' rel='noopener noreferrer'>Discovery</a></li>
            <li className='about_list-items'><a href="https://www.instagram.com/stories/highlights/18108726367276478/" target='_blank' rel='noopener noreferrer'>BBC Earth</a></li>
            <li className='about_list-items'>NatureInFocus</li>
            <li className='about_list-items'><a href="https://www.instagram.com/stories/highlights/17963114405180848/" target='_blank' rel='noopener noreferrer'>National Geographic India</a></li>
          </ul>
        </div>
      </div>
      <img className='brands' src={brands} alt="Brands" />
    </div>
    <div className="w-1">
      <div className="awards">
        <a className='awards__image' href="https://35awards.com/page/contests/num/554/photographers/" target='_blank' rel='noopener noreferrer'>
          <img src={Monkey_Photographers} alt="Monkey Photographers" />
        </a>
        <Links
          target='_blank'
          text='35 Awards Top 5 Monkey Photographers'
          path='https://35awards.com/page/contests/num/554/photographers/'
        />
      </div>
      <div>
        <AboutCards
        img={ceylon_today}
        linkStyle={{margin:'20px 0'}}
        content='Welcome to my media page, a treasure trove of my stories captured through both the magic of photography and the power of the written word. Here, you’ll find a curated selection of my published works, ranging from feature articles in renowned magazines to captivating spreads in prestigious newspapers.'
        path='/publications'
        />
        <AboutCards
        img={youtube}
        linkStyle={{margin:'20px 0'}}
        content='Step into the heart of Sri Lanka’s breathtaking wilderness with WILD Serendib, your gateway to adventure, discovery, and the raw beauty of nature. Join award-winning wildlife photographer and tour guide Ravisara Jayamanna as he takes you on an unforgettable journey through misty mountains, lush rainforests, and vibrant coral reefs.'
        path='https://www.youtube.com/@wildserendib5042'
        target='_blank'
        cardStyle={{flexDirection:'row-reverse'}}
        />
      </div>
      <Gc style={{padding:'5px', height:'40vh'}} items={items2} />;
      <Gc style={{padding:'5px', height:'60vh'}} items={items1} />;
    </div>
  </div>
  </Helmet>
  </>
}

export default About